// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Either_Extra from "../Data.Either.Extra/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Restaumatic_Services_Geocoding_Cached from "../Restaumatic.Services.Geocoding.Cached/index.js";
import * as Restaumatic_Services_Geocoding_Higgs from "../Restaumatic.Services.Geocoding.Higgs/index.js";
import * as Restaumatic_Services_Storage_LocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
var defaultJSGeocoding = function (accountId) {
    return function (restaurantId) {
        return Restaumatic_Services_Geocoding_Cached.cachedGeocoding({
            storage: Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback,
            key: "locationCache"
        })(Restaumatic_Services_Geocoding_Higgs.higgsGeocoding(accountId)(restaurantId)(false));
    };
};
var geocodeJS = function (v) {
    return function __do() {
        var v1 = Data_Either_Extra.unsafeFromRight(Data_List_Types.showNonEmptyList(Foreign.showForeignError))("GeocodeData")(Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "streetAddress";
            }
        })(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "streetNumber";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
            reflectSymbol: function () {
                return "street";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
            reflectSymbol: function () {
                return "city";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))()))())({
            reflectSymbol: function () {
                return "country";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_TypesGen.decodeCountry))()))(v.params)))();
        var restaurantIdMb = Control_Bind.join(Data_Maybe.bindMaybe)(Data_Either.hush(Control_Monad_Except.runExcept(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function () {
            var $15 = Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_Restaurant_Types_Id.RestaurantId);
            return function ($16) {
                return $15(Data_Int.fromString($16));
            };
        })())(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)(v.restaurantId)))));
        var geocode = (defaultJSGeocoding(Data_Maybe.Nothing.value)(restaurantIdMb)).geocodeAddress(v1.country)(v1.streetAddress);
        return Effect_Aff.runAff_(function (v2) {
            if (v2 instanceof Data_Either.Left) {
                return v.onError;
            };
            if (v2 instanceof Data_Either.Right) {
                return v.onSuccess(Foreign_Generic_Class.encode(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "longitude";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "latitude";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))))(v2.value0));
            };
            throw new Error("Failed pattern match at Restaumatic.Services.Geocoding.Default (line 53, column 7 - line 55, column 40): " + [ v2.constructor.name ]);
        })(Data_Functor.map(Effect_Aff.functorAff)(function ($17) {
            return (function (x) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(x)(function (v2) {
                    return v2.location;
                });
            })(Data_Either.hush($17));
        })(geocode))();
    };
};
var defaultGeocoding = function (restaurantId) {
    return Restaumatic_Services_Geocoding_Cached.cachedGeocoding({
        storage: Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback,
        key: "locationCache"
    })(Restaumatic_Services_Geocoding_Higgs.higgsGeocoding(Data_Maybe.Nothing.value)(new Data_Maybe.Just(restaurantId))(true));
};
export {
    defaultGeocoding,
    defaultJSGeocoding,
    geocodeJS
};
//# sourceMappingURL=index.js.map
